import {showNotification} from 'platform/components';
import {match} from 'ts-pattern';

import {useState} from 'react';

import {isNil} from 'ramda';

import {testIds, tiresInventoryRoutes} from '@dms/routes';
import {DmsDataGrid, refreshDmsDatagrid, TireSetDetail} from '@dms/shared';

import {composePath} from 'shared/web';

import type {ActionCallback} from 'features/eag-grid';

const PREDEFINED_COLUMNS = [
  'orderId',
  'orderSetId',
  'tireManufacturer',
  'tireSeason',
  'setNumber',
] as const;

export function TierListOverview() {
  const [editingTireSetData, setEditingTireSetData] = useState<{
    tireOrderId: string;
    setId: string;
  } | null>(null);

  const actionCallback: ActionCallback<typeof PREDEFINED_COLUMNS> = ({
    actionKey,
    getColumnData,
  }) => {
    const orderId = getColumnData<string>('orderId')?.value;
    const orderSetId = getColumnData<string>('orderSetId')?.value;

    if (isNil(orderId) || isNil(orderSetId)) {
      throw new Error('orderId or orderSetId is undefined');
    }

    match(actionKey)
      .with('redirectDetail', () => {
        setEditingTireSetData({
          tireOrderId: orderId,
          setId: orderSetId,
        });
      })
      .with('redirectTireOrder', () =>
        window.open(
          composePath(tiresInventoryRoutes.tireOrderDetail, {
            params: {id: orderId},
            queryParams: {source: 'tire-list'},
          }),
          '_blank'
        )
      )
      .otherwise(() => showNotification.error(`Action ${actionKey} is not implemented`));
  };

  const handleCloseEditTireSet = () => {
    setEditingTireSetData(null);
  };

  const handleEditTireSet = () => {
    refreshDmsDatagrid('tire-list');
    setEditingTireSetData(null);
  };

  return (
    <>
      <DmsDataGrid
        gridCode="tire-list"
        actionCallback={actionCallback}
        predefinedColumns={PREDEFINED_COLUMNS}
        data-testid={testIds.tiresInventory.tireList('grid')}
      />
      {editingTireSetData && (
        <TireSetDetail
          tireOrderId={editingTireSetData.tireOrderId}
          tireSetId={editingTireSetData.setId}
          onClose={handleCloseEditTireSet}
          onEdit={handleEditTireSet}
        />
      )}
    </>
  );
}
